/**
 * Get footer status
 * @param {object} state - The vuex state object
 * @return {Boolean} Footer status
 */
export const getFooterStatus = (state) => state.isShown;
